import * as XLSX from 'xlsx'

function marginPct(price, cost) {
    const p = Number(price)
    const c = Number(cost)
    if (!p || p <= 0) return 0
    return parseFloat((((p - c) / p) * 100).toFixed(1))
}

function fmtMoney(n) {
    return Number(n || 0)
}

function joinBullets(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return ''
    return arr.join('\n')
}

function buildProductsData(items) {
    return items.map(item => ({
        ID: item.id,
        Category: item.cat || '',
        Name: item.name || '',
        Price: fmtMoney(item.price),
        Cost: fmtMoney(item.cost),
        Unit: item.unit || '',
        'Margin %': marginPct(item.price, item.cost),
        Subcategory: item.subcat || '',
        'Is Custom': item.is_custom ? 'TRUE' : 'FALSE',
    }))
}

function buildScopeDetailsData(items) {
    const rows = []
    for (const item of items) {
        const inc = Array.isArray(item.inc) ? item.inc : []
        const exc = Array.isArray(item.exc) ? item.exc : []
        for (const text of inc) {
            rows.push({
                'Product ID': item.id,
                Type: 'INC',
                'Bullet Text': text,
            })
        }
        for (const text of exc) {
            rows.push({
                'Product ID': item.id,
                Type: 'EXC',
                'Bullet Text': text,
            })
        }
    }
    return rows
}

function buildFlatData(items) {
    return items.map(item => ({
        ID: item.id,
        Category: item.cat || '',
        Name: item.name || '',
        Price: fmtMoney(item.price),
        Cost: fmtMoney(item.cost),
        Unit: item.unit || '',
        'Margin %': marginPct(item.price, item.cost),
        Subcategory: item.subcat || '',
        'Is Custom': item.is_custom ? 'TRUE' : 'FALSE',
        Inclusions: joinBullets(item.inc),
        Exclusions: joinBullets(item.exc),
    }))
}

function buildHorizontalData(items) {
    const maxInc = items.reduce((m, i) => Math.max(m, Array.isArray(i.inc) ? i.inc.length : 0), 0)
    const maxExc = items.reduce((m, i) => Math.max(m, Array.isArray(i.exc) ? i.exc.length : 0), 0)

    return items.map(item => {
        const row = {
            ID: item.id,
            Category: item.cat || '',
            Name: item.name || '',
            Price: fmtMoney(item.price),
            Cost: fmtMoney(item.cost),
            Unit: item.unit || '',
            'Margin %': marginPct(item.price, item.cost),
            Subcategory: item.subcat || '',
            'Is Custom': item.is_custom ? 'TRUE' : 'FALSE',
        }
        const inc = Array.isArray(item.inc) ? item.inc : []
        const exc = Array.isArray(item.exc) ? item.exc : []
        for (let i = 0; i < maxInc; i++) {
            row[`INC_${i + 1}`] = inc[i] || ''
        }
        for (let i = 0; i < maxExc; i++) {
            row[`EXC_${i + 1}`] = exc[i] || ''
        }
        return row
    })
}

export function exportTwoSheet(items) {
    const wb = XLSX.utils.book_new()
    const products = buildProductsData(items)
    const scope = buildScopeDetailsData(items)

    const ws1 = XLSX.utils.json_to_sheet(products)
    const ws2 = XLSX.utils.json_to_sheet(scope)

    XLSX.utils.book_append_sheet(wb, ws1, 'Products')
    XLSX.utils.book_append_sheet(wb, ws2, 'Scope Details')
    return wb
}

export function exportFlatSheet(items) {
    const wb = XLSX.utils.book_new()
    const data = buildFlatData(items)
    const ws = XLSX.utils.json_to_sheet(data)
    XLSX.utils.book_append_sheet(wb, ws, 'Catalog')
    return wb
}

export function exportHorizontalSheet(items) {
    const wb = XLSX.utils.book_new()
    const data = buildHorizontalData(items)
    const ws = XLSX.utils.json_to_sheet(data)
    XLSX.utils.book_append_sheet(wb, ws, 'Catalog')
    return wb
}

export function downloadWorkbook(wb, filename) {
    XLSX.writeFile(wb, filename)
}

export function getExportFilename() {
    const date = new Date().toISOString().slice(0, 10)
    return `JD-Rivero-Catalog-${date}.xlsx`
}
